//#region src/properties/pickListingHighlights.ts
var e = 3, t = [
	"features",
	"amenities",
	"essentials"
], n = (e, n) => t.flatMap((t) => e.filter((e) => e.category === t && n.has(e.slug))).slice(0, 3);
//#endregion
export { e as MAX_LISTING_HIGHLIGHTS, n as pickListingHighlights };
